import _ from 'lodash'
import dayjs from 'dayjs'
import { Message } from 'element-ui';

function isMobile() {
  let ua = navigator.userAgent || '';
  let YZJ = (ua.indexOf("Qing/") !== -1 || ua.indexOf("App/cloudhub") !== -1);
  return /(iPhone|iPad|Android|IEMobile|dingTalk|micromessenger)/ig.test(ua) || YZJ;
}

function ml(str) {
  if (process.env.NODE_ENV == 'development') {
    return str.match(/\[\[(\S*)\]\]/)[1];
  } else {
    return str;
  }
}

function fmt(d, f) {
  if (!d) return '无';
  if (!f) f = 'YYYY-MM-DD';
  if(f=='_s') f = 'YYYY-MM-DD HH:mm:ss';
  if(f=='_m') f = 'YYYY-MM-DD HH:mm';
  return dayjs(d).format(f);
}

let r = {};
function vBack(id, func) {
  if (!r.__w2backs) {
    r.__w2backs = { funcs: {}, queues: [] };
    window.$(document).on('mouseover', () => {
      if (r.__w2backs.queues.length > 0) {
        let qs = r.__w2backs.queues;
        r.__w2backs.queues = [];
        _.map(qs, q => q());
      }
    });
  }
  if (func) return r.__w2backs.funcs[id] = func;
  r.__w2backs.queues.push(r.__w2backs.funcs[id]);
}

//
function copy(copytext) {
  if (!copytext) return Message.warning('无内容可复制');
  var input = document.createElement('input');
  input.setAttribute('readonly', 'readonly'); // 防止手机上弹出软键盘
  input.setAttribute('value', copytext);
  document.body.appendChild(input);
  input.select();
  var result = document.execCommand('copy');
  if (result) {
    document.body.removeChild(input);
    Message.success('已复制到剪切板');
  }

}

// 校验 URL
function validUrl(url) {
  const reg =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}
// 生成随机数
function randomNum(n) {
  var res = "";
  for (var i = 0; i < n; i++) {
    res += Math.floor(Math.random() * 10);
  }
  return res;
}
// 解构数据
function getTreeParents(treeData, childrenStr) {
  let _this = this;
  const parentKey = []
  treeData.forEach((item) => {
    if (item[childrenStr] && item[childrenStr].length) {
      parentKey.push([...item[childrenStr]])
      const temp = _this.getTreeParents(item[childrenStr], childrenStr)
      if (temp?.length) {
        parentKey.push([].concat.apply([], temp))
      }
    }
  })
  return parentKey
}


//  下载/导出
function downloadFile(url) {
  const link = document.createElement('a'); //创建下载a标签
  link.href = url;
  link.target = "_blank";//新页面打开
  link.style.display = 'none'; //默认隐藏元素
  document.body.appendChild(link); // body中添加元素
  link.click(); // 执行点击事件
  document.body.removeChild(link);//下载完成后移除元素
}
export {
  isMobile,
  ml,
  fmt,
  vBack,
  copy,
  validUrl,
  randomNum,
  getTreeParents,
  downloadFile,
}